/**
 * Created by nico on 22/12/14.
 */
(function () {
  angular.module('pentaApp').factory('errorLog.resource', service);

  service.$inject = ['$resource'];
  function service($resource) { return $resource('/api/errorLog'); }

})();